import {
  Menu,
  MenuItem,
  Box,
  Typography,
  useTheme,
  Checkbox,
  alpha,
  Tooltip,
  Divider,
  Stack,
} from "@mui/material";
import useStyles from "./styles";
import { useState, useRef, useEffect, Fragment } from "react";

import CloseIcon from "@mui/icons-material/CloseRounded";
import { ArrowDropDown } from "@mui/icons-material";
import styled from "styled-components";

interface SelectFilterProps {
  label: string;
  options: string[];
  value: string[];
  onChange: (value: any, type?: string) => void;
  // onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  onClose: () => void;
  disabled?: boolean;
}

interface TagProps {
  label: string;
  onDelete?: (event: React.MouseEvent<SVGSVGElement>) => void;
  [key: string]: any;
}
const BpIcon = styled("span")<{ isFocused: boolean }>((props) => {
  const { isFocused } = props;
  const theme = useTheme();
  return {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: `inset 0 0 0 1px ${alpha(
      theme.palette.background.default,
      0.2,
    )}, inset 0 -1px 0 ${alpha(theme.palette.background.default, 0.2)}`,
    // backgroundColor: isFocused
    //   ? theme.palette.text.disabled
    //   : theme.palette.background.textField,
    backgroundColor: theme.palette.background.textField,
    "input:hover ~ &": {
      // backgroundColor: alpha(theme.palette.text.disabled, 0.5),
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: theme.palette.text.disabled,
    },
  };
});
const BpCheckedIcon = styled(BpIcon)<{ isFocused: boolean }>((props) => {
  const { isFocused } = props;
  const theme = useTheme();
  return {
    backgroundImage:
      "linear-gradient(180deg,hsla(133, 52.10%, 36.90%, 0.22),hsla(0,0%,100%,0))",
    "&::before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    backgroundColor: isFocused
      ? theme.palette.primary.dark
      : theme.palette.text.disabled,
    "input:hover ~ &": {
      backgroundColor: theme.palette.primary.dark,
    },
  };
});
function Tag(props: TagProps) {
  const { label, onDelete, ...other } = props;
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Tooltip
      title={label}
      placement="top"
      slotProps={{
        tooltip: {
          sx: {
            fontWeight: "bold",
            fontSize: "0.75rem",
            bgcolor: theme.palette.background.textField,
          },
        },
      }}
    >
      <Box {...other} key={`filter-${label}`} sx={styles.divTag(!!onDelete)}>
        <Typography sx={styles.textTag}>{label}</Typography>
        {onDelete ? (
          <CloseIcon sx={styles.closeIcon} onClick={onDelete} />
        ) : null}
      </Box>
    </Tooltip>
  );
}
export interface CustomFiltersSelectRef {
  resetFilterSelect: () => any;
}

const SelectFilter: React.FC<SelectFilterProps> = (props) => {
  const { label, options, value, onChange, onClose, disabled } = props;
  const inputRef = useRef(null);
  const theme = useTheme();
  const [listBoxWidth, setListBoxWidth] = useState(0);
  // const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [focused, setFocused] = useState<string>();
  const open = Boolean(anchorEl);
  const styles = useStyles(theme, Boolean(anchorEl));
  const optionsGrouped = options.reduce(
    (acc: string[], option: string, index: number) => {
      const findOption = acc.find((item: any) => item === option);
      if (!findOption) {
        acc.push(option);
      }
      return acc;
    },
    [],
  );

  useEffect(() => {
    if (inputRef.current) {
      const { offsetWidth } = inputRef.current;
      setListBoxWidth(offsetWidth);
    }
  }, [value]);

  const isAllSelected = value?.length === optionsGrouped?.length;

  return (
    <Fragment key={"containerB"}>
      <Box sx={styles.boxContainer}>
        <Box
          ref={inputRef}
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
            event.stopPropagation();
          }}
          sx={styles.boxInputSelect}
        >
          <Typography sx={styles.label}>{label.toUpperCase()}</Typography>
          <Box sx={styles.boxTags}>
            {isAllSelected ? (
              <Tag key={0} label={"todos"} />
            ) : (
              <>
                {(open ? value?.slice(0, 3) : value.slice(0, 1)).map(
                  (option, index) => (
                    <Tag
                      key={option + index}
                      label={option ?? "Sem " + label?.toLowerCase()}
                      onDelete={(event) => {
                        event.stopPropagation();
                        const newSelectedValue = value.filter(
                          (item) => item !== option,
                        );

                        onChange(newSelectedValue, "tag");
                      }}
                    />
                  ),
                )}
                {value.length > 3 && open && (
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 500,
                      color: "text.secondary",
                      alignSelf: "center",
                    }}
                  >
                    ...
                  </Typography>
                )}
              </>
            )}

            <input style={{ ...styles.input, boxSizing: "border-box" }}></input>
          </Box>
          {!isAllSelected && !Boolean(anchorEl) && value.length > 1 && (
            <Stack
              sx={{
                backgroundColor: alpha(theme.palette.background.textField, 0.8),
                padding: 0.5,
                marginY: 0.8,
                borderRadius: "0.3rem",
              }}
            >
              <Typography sx={styles.textTag}>+{value.length - 1}</Typography>
            </Stack>
          )}
          <ArrowDropDown sx={{ fontSize: 20, color: "text.secondary" }} />
        </Box>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          if (value.length === 0) {
            onChange(optionsGrouped);
            // setIsAllSelected(true);
          }
          onClose();
          setAnchorEl(null);
        }}
        sx={styles.menu(listBoxWidth)}
        autoFocus={false}
        disableAutoFocusItem={true}
        disableEnforceFocus
      >
        <MenuItem
          key={`selectedItem-all`}
          disableTouchRipple={true}
          disableRipple={true}
          sx={styles.menuItem(isAllSelected, false)}
          onMouseEnter={() => setFocused("selectAll")}
          onMouseLeave={() => setFocused("")}
          onClick={() => {
            if (!isAllSelected) onChange(optionsGrouped);
            else {
              onChange([]);
            }
          }}
          disabled={disabled}
        >
          <Checkbox
            checked={isAllSelected}
            size="small"
            color="primary"
            disableTouchRipple={true}
            checkedIcon={<BpCheckedIcon isFocused={focused === "selectAll"} />}
            icon={<BpIcon isFocused={focused === "selectAll"} />}
            sx={{ m: -1, "&:hover": { bgcolor: "transparent" } }}
          />
          Selecionar tudo
        </MenuItem>
        {/* <Button
          sx={styles.menuItemSelectAll(isAllSelected)}
          startIcon={<DoneAllRounded />}          
          disabled={isAllSelected}
          onClick={() => {
            if (!isAllSelected) onChange(optionsGrouped);
          }}
        >
          Selecionar tudo
        </Button> */}
        <Divider />
        {optionsGrouped.map((option, index) => {
          const isSelected = value.includes(option);
          const isFocused = focused === option;
          return (
            <Tooltip title={option}>
              <MenuItem
                key={`selectedItem-${index}`}
                sx={{
                  ...styles.menuItem(isSelected, false),
                  "&.Mui-disabled": {
                    filter: "opacity(1)",
                  },
                }}
                onMouseEnter={() => setFocused(option)}
                onMouseLeave={() => setFocused("")}
                onClick={() => {
                  let newSelectedValue: any = value.includes(option)
                    ? value.filter((item) => item !== option)
                    : [...value, option];
                  // if (newSelectedValue.length === 0) {
                  //   return;
                  // }
                  // if (newSelectedValue.length === optionsGrouped.length) {
                  //   setIsAllSelected(true);
                  // }
                  onChange(newSelectedValue);
                }}
                disabled={disabled}
              >
                <Checkbox
                  checked={isSelected}
                  size="small"
                  color="primary"
                  disableRipple
                  checkedIcon={<BpCheckedIcon isFocused={isFocused} />}
                  icon={<BpIcon isFocused={isFocused} />}
                  sx={{ m: -1, "&:hover": { bgcolor: "transparent" } }}
                />
                <Typography
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    width: "fit-content",
                    maxWidth: "100%",
                    textOverflow: "ellipsis",
                  }}
                >
                  {option ?? "Sem " + label?.toLowerCase()}
                </Typography>
              </MenuItem>
            </Tooltip>
          );
        })}
      </Menu>
    </Fragment>
  );
};
export default SelectFilter;
